// extracted by mini-css-extract-plugin
export default {"bigContainer":"Landing_bigContainer__kI7Tl"};